import { useSelector } from 'react-redux'
import useAdAccountLogin from 'features/account/useAdAccountLogin'
import { AD_ACCOUNT_STATUS } from 'features/account/accountSlice'
import { useParams } from 'react-router-dom'
import Lnb from '../../features/lnb/Lnb'
import Unauthorized from '../error/Unauthorized'
import PropTypes from 'prop-types'
import { Fragment } from 'react'

const AdAccountLayout = ({ children }) => {
  useAdAccountLogin()
  const { accountId } = useParams()
  const { current, status } = useSelector(state => state.account)
  if (
    current?.id === Number(accountId) &&
    status === AD_ACCOUNT_STATUS.SUCCESS
  ) {
    return (
      <>
        <Lnb />
        {children}
      </>
    )
  } else if (status === AD_ACCOUNT_STATUS.UNAUTHORIZED) {
    return <Unauthorized />
  } else {
    return <Fragment />
  }
}
AdAccountLayout.propTypes = {
  children: PropTypes.node.isRequired,
}
export default AdAccountLayout
